import  { Markup } from 'interweave';
import React from 'react';

export const ContentBody = (props: any) => {
    const { description, className } = props;
    let cleared = description.replace(/<br\s*\/?>/gi,'\n');
    const paragraphs = cleared.split('\n');

    let classes = 'event-description container'
    if (className) {
        classes = `${classes} ${className}`;
    }
    return <div className={classes}>
        {paragraphs.map((p:string, idx: number) => <Markup key={idx} content={p.replace(new RegExp('\r?\n','g'), '<br />')}/> )}
    </div>
}
